import { render } from "./EditProduitPage.vue?vue&type=template&id=732fdc21&ts=true"
import script from "./EditProduitPage.vue?vue&type=script&lang=ts"
export * from "./EditProduitPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__